import { onMounted, onUnmounted } from 'vue';

/**
 * Composable to intercept cart navigation links when in edit mode
 * Uses event delegation for optimal performance and automatic handling of dynamic links
 *
 * @param {Function} isEditMode - Function that returns true if in edit mode
 * @param {Function} handleSave - Function to call to save changes before navigating
 */
export function useCartLinkInterceptor(isEditMode, handleSave) {
  let clickHandler = null;

  onMounted(() => {
    // Use event delegation with capture phase for reliable interception
    clickHandler = (event) => {
      // Find if click target or any parent is a cart link
      const target = event.target.closest('a[href="/winkelmandje"]');

      if (target && isEditMode()) {
        event.preventDefault();
        event.stopPropagation();

        // Save changes and navigate to cart
        handleSave();
      }
    };

    // Use capture phase to intercept before other handlers
    document.addEventListener('click', clickHandler, true);
  });

  onUnmounted(() => {
    if (clickHandler) {
      document.removeEventListener('click', clickHandler, true);
    }
  });
}
